import React from "react";

interface ISquareBracesIconProps {
    size?: number;
    color?: string;
    type?: "left" | "right";
}

export const SquareBracesIcon: React.FC<ISquareBracesIconProps> = ({ size = 24, color = "black", type = "left" }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            {type === "right" && <path
                d="M59.28 78.6399H40.272V72.7519H59.28V78.6399ZM59.28 27.2479H40.272V21.3599H59.28V27.2479ZM59.728 78.6399H52.688V21.3599H59.728V78.6399Z"
                fill={color}/>}
            {type === "left" && <path
                d="M40.72 78.6399V72.7519H59.728V78.6399H40.72ZM40.72 27.2479V21.3599H59.728V27.2479H40.72ZM40.272 78.6399V21.3599H47.312V78.6399H40.272Z"
                fill={color}/>}
        </svg>
    );
};
